export default function getCanonicalUrl(path: string): string | undefined {
  if (!path) {
    return "";
  }

  if (path.trim() === "home") {
    return process.env.NEXT_PUBLIC_HOST || "";
  }

  const cleanedPath = path.toLowerCase().replace(/^\/?|\/?$/g, "");
  const encodedPath = encodeURI(cleanedPath);

  return `${process.env.NEXT_PUBLIC_HOST}/${encodedPath}`;
}
